import pt from "date-fns/locale/pt";
import { format } from "date-fns";

export const formatDate = (__date, __type) => {
  if (__date) {
    let _date = typeof __date === "string" ? stringToDate(__date) : __date;

    if (__type === 1) {
      return format(_date, "dd'/'MM'/'yyyy' 'HH':'mm", { locale: pt });
    } else if (__type === 2) {
      return format(_date, "dd'/'MM'/'yyyy", { locale: pt });
    } else if (__type === 3) {
      return format(_date, "yyyy'-'MM'-'dd'", { locale: pt });
    } else if (__type === 4) {
      return format(_date, "dd 'de' MMMM 'de' yyyy 'às' HH':'mm", { locale: pt });
    } else if (__type === 5) {
      return format(_date, "dd'/'MM'/'yyyy' às 'HH':'mm", { locale: pt });
    } else if (__type === 6) {
      return format(_date, "'às 'HH':'mm", { locale: pt });
    } else if (__type === 7) {
      return format(_date, "dd'/'MM'/'yyyy'", { locale: pt });
    } else if (__type === 8) {
      return format(_date, "yyyy", { locale: pt });
    } else if (__type === 9) {
      return format(_date, `EEEE`, { locale: pt });
    } else if (__type === 10) {
      return format(_date, `dd 'de' MMMM 'de' yyyy`, { locale: pt });
    } else if (__type === 11) {
      return format(_date, `MMMM yyyy`, { locale: pt });
    } else if (__type === 12) {
      return format(_date, "HH':'mm", { locale: pt });
    }
  }
};

export const stringToDate = __date_str => {
  if (__date_str instanceof Date) return __date_str;
  let _date = __date_str;
  if (typeof __date_str === "string" && !__date_str.includes("Z") && __date_str.includes("-")) {
    if (__date_str.includes(" ")) {
      _date = _date.replace(" ", "T") + ".000-03:00";
    } else {
      _date = __date_str + "T00:00:00.000-03:00";
    }
  }
  return new Date(_date);
};

const formatReal = __value => {
  let _negative = __value < 0;
  let _value = parseFloat(Math.abs(__value) || 0).toFixed(2);
  _value = _value.replace(".", ",");
  _value = _value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${_negative ? "- " : ""}R$ ${_value}`;
};

export const formatPhone = value => {
  let phoneNumbers = String(value).replace(/[^a-zA-Z0-9 ]/g, "");
  phoneNumbers = phoneNumbers.replace(/\D/g, "");
  phoneNumbers = phoneNumbers.replace(/(\d{2})(\d)/, "($1) $2");
  phoneNumbers = phoneNumbers.replace(/(\d)(\d{4})$/, "$1-$2");
  return phoneNumbers;
};

export const capitalizeFirst = __value => {
  if (__value) {
    const _words = __value.split(" ");
    const _words_upper = _words.map(__word => `${__word.charAt(0).toUpperCase()}${__word.slice(1)}`);
    const _phrase = _words_upper.join(" ");
    return _phrase;
  }
};

export const uniqObject = props => {
  const { array, key } = props;
  const _uniq = [...new Map(array.map(_el => [_el[key], _el])).values()];
  return _uniq;
};

export const sortObject = props => {
  const { array, key, type = "string" } = props;
  array.sort((a, b) => {
    if (type === "string") {
      return a[key].localeCompare(b[key]);
    } else if (type === "date") {
      return new Date(a[key]) < new Date(b[key]);
    } else {
      return a[key] < b[key];
    }
  });
  return array;
};

export const validCPF = __value => {
  let _value = __value.replace(/[^0-9]/g, "");
  if (
    _value === "00000000000" ||
    _value === "11111111111" ||
    _value === "22222222222" ||
    _value === "33333333333" ||
    _value === "44444444444" ||
    _value === "55555555555" ||
    _value === "66666666666" ||
    _value === "77777777777" ||
    _value === "88888888888" ||
    _value === "99999999999"
  ) {
    return false;
  }
  if (_value.length !== 11) return false;
  let soma = 0;
  let resto;
  for (let i = 1; i <= 9; i++) {
    soma = soma + parseInt(_value.substring(i - 1, i)) * (11 - i);
  }
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(_value.substring(9, 10))) return false;
  soma = 0;
  for (let i = 1; i <= 10; i++) {
    soma = soma + parseInt(_value.substring(i - 1, i)) * (12 - i);
  }
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(_value.substring(10, 11))) return false;
  return true;
};

export const validCNPJ = __value => {
  let b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  let c = String(__value).replace(/[^\d]/g, "");
  if (c.length !== 14) return false;
  if (/0{14}/.test(c)) return false;
  for (var i = 0, n = 0; i < 12; n += c[i] * b[++i]);
  if (Number(c[12]) !== ((n %= 11) < 2 ? 0 : 11 - n)) return false;
  for (i = 0, n = 0; i <= 12; n += c[i] * b[i++]);
  if (Number(c[13]) !== ((n %= 11) < 2 ? 0 : 11 - n)) return false;
  return true;
};

export const validEmail = __value => {
  return String(__value)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
};

export function capitalizeFirstLetter(__string) {
  return __string.charAt(0).toUpperCase() + __string.slice(1);
}

export function formatLogs(props) {
  const { logs, type } = props;
  const _subject =
    type === "payments"
      ? {
          label: "Pagamento",
          gender: "o",
        }
      : {};

  const getAction = props => {
    const { action, agent, action_date, message_error } = props;
    const _agent_post = !!agent ? ` por ${agent}` : "";
    const _action_date = !!action_date ? ` em ` : "";
    const _post_fix = `${_agent_post}${_action_date}`;

    return action === "create"
      ? `criad${_subject?.gender}${_post_fix}`
      : action === "generate"
        ? `gerad${_subject?.gender}${_post_fix}`
        : action === "cancel"
          ? `cancelad${_subject?.gender}${_post_fix}`
          : action === "paid"
            ? `realizad${_subject?.gender}${_post_fix}`
            : action === "update"
              ? `atualizad${_subject?.gender}${_post_fix}`
              : action === "manual_payment"
                ? `manual confirmad${_subject?.gender}${_post_fix}`
                : action === "cancelBank"
                  ? `cancelad${_subject?.gender} pelo Banco`
                  : message_error || "Erro";
  };
  return logs.map((__log, __log_i) => (
    <>
      {__log_i !== 0 ? <br /> : ""}[{formatDate(__log?.created_at, 1)}] {_subject?.label}{" "}
      {getAction({
        action: __log?.type,
        agent: __log?.users?.username || __log?.trainees?.name,
        message_error: __log?.message_error || "",
        action_date: __log?.action_date,
      })}
    </>
  ));
}

export function clearEmptyEntries(__object) {
  return Object.fromEntries(
    Object.entries(__object)?.filter(
      __entrie => __entrie[1] !== null && __entrie[1] !== undefined && __entrie[1] !== "",
    ),
  );
}

export function formatQuery(__query_obj) {
  let _query = clearEmptyEntries(__query_obj);

  _query = Object.fromEntries(
    Object.entries(_query)?.map(__entrie => {
      const [_key, _value] = __entrie;
      if (_value instanceof Date) return [_key, formatDate(_value, 3)];
      else return __entrie;
    }),
  );

  _query = new URLSearchParams(_query);
  return _query.toString();
}

export function formatName(__name) {
  if (!__name) return;
  const [_first_name, ..._sur_names] = __name.trim().split(" ");
  const _last_name = _sur_names?.[_sur_names.length - 1] || "";
  return `${_first_name}${!!_last_name ? ` ${_last_name}` : ""}`;
}

export function formatFileSize(bytes, si = false, dp = 1) {
  const thresh = si ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) {
    return bytes + " B";
  }

  const units = si
    ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
  let u = -1;
  const r = 10 ** dp;

  do {
    bytes /= thresh;
    ++u;
  } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

  return bytes.toFixed(dp) + " " + units[u];
}

const useFormatDate = () => {
  return {
    formatDate,
    formatReal,
    formatPhone,
    capitalizeFirst,
    uniqObject,
    validCPF,
    validCNPJ,
    sortObject,
    validEmail,
    capitalizeFirstLetter,
    formatLogs,
    clearEmptyEntries,
    formatQuery,
    formatName,
    formatFileSize,
    stringToDate,
  };
};

export default useFormatDate;
